// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"178":"2665251a","843":"1f318bf8","975":"96a2717c","993":"96a2717c","1485":"96a2717c","1999":"96a2717c","2868":"96a2717c","2930":"cfcd808c","2938":"2665251a","3954":"96a2717c","4906":"96a2717c","4998":"96a2717c","5836":"db4027f5","6268":"96a2717c","7939":"7c18de70"}[chunkId] + ".chunk.css";
};